import {FormSubmissionData} from "../forms/interfaces/form-submission-data";
import {PageField} from "../forms/interfaces/page-field";

export function getSubmittedFieldLabel(field: PageField, submissionData: FormSubmissionData[]): string {
  const matchingData = submissionData.find((datum) => datum.fieldId === field.id);

  return matchingData?.fieldLabel || field.label;
}
